var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Radio,_vm._g(_vm._b({},'Radio',_vm.$attrs,false),_vm.$listeners),[_vm._t("default",function(){return [_vm._v(_vm._s(_vm.text))]}),_vm._v(" "),(_vm.tip)?_c(_setup.PgTextTip,{attrs:{"text":_vm.tip}}):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }